var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVectorPen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.6881 17.9048H18C18.5523 17.9048 19 18.3632 19 18.9286V20.9762C19 21.5416 18.5523 22 18 22H6C5.44772 22 5 21.5416 5 20.9762V18.9286C5 18.3632 5.44772 17.9048 6 17.9048H6.31187L5.09239 13.5647C4.90855 12.9104 5.00238 12.1911 5.34432 11.6333L11.25 2V8.78757C9.95608 9.12853 9 10.3311 9 11.7622C9 13.4585 10.3431 14.8336 12 14.8336C13.6569 14.8336 15 13.4585 15 11.7622C15 10.3311 14.0439 9.12853 12.75 8.78757V2L18.6557 11.6333C18.9976 12.1911 19.0915 12.9104 18.9076 13.5647L17.6881 17.9048Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVectorPen);
export default __webpack_public_path__ + "static/media/vector-pen.f14301ed6f6d6413d72a134f4fba5d83.svg";
export { ForwardRef as ReactComponent };